
<template>
  <div id="app">
    <ag-navbar
      ref="navbar"
      :user="user"
      :page="page"
      @setPage="setPage"
      @changePassword="changePassword"
      @showLicense="showLicense">
    </ag-navbar>

    <b-container ref="pageContainer" class="agPageContainer">
      <ag-invalid-page v-if="page == 'invalid'" class="agPage"></ag-invalid-page>
      <ag-workflows-page v-if="page == 'workflows'" class="agPage" @setPage="setPage"></ag-workflows-page>
      <ag-connections-page v-else-if="page == 'connections'" class="agPage"></ag-connections-page>
      <ag-logs-page v-else-if="page == 'logs'" class="agPage"></ag-logs-page>
      <ag-workflow-editor v-else-if="page == 'workflowEditor'" ref="workflowEditor" class="agPage"></ag-workflow-editor>
      <ag-workspaces-page v-else-if="page=='workspaces'" class="agPage"></ag-workspaces-page>
      <ag-users-groups-page v-else-if="page == 'usersGroups'" class="agPage"></ag-users-groups-page>
    </b-container>

    <ag-alert-modal ref="alertModal"></ag-alert-modal>
    <ag-login-modal ref="loginModal"></ag-login-modal>
    <ag-password-modal ref="passwordModal"></ag-password-modal>
    <ag-license-modal ref="licenseModal"></ag-license-modal>
  </div>
</template>






<script>
// components
import Navbar from "ui/Navbar";
import AlertModal from "ui/AlertModal";
import InvalidPage from "comp/InvalidPage";
import WorkflowsPage from "workflow/WorkflowsPage";
import ConnectionsPage from "connection/ConnectionsPage";
import LogsPage from "log/LogsPage";
import WorkflowEditor from "workflow/WorkflowEditor";
import WorkspacesPage from "workspace/WorkspacesPage";
import UsersGroupsPage from "user/UsersGroupsPage";
import LoginModal from "user/LoginModal";
import PasswordModal from "user/PasswordModal";
import LicenseModal from "user/LicenseModal";

// modules
import Server from "src/server";
import { EventBus } from "src/eventBus";

export default {
  name: "App",
  components: {
    "ag-navbar": Navbar,
    "ag-alert-modal": AlertModal,
    "ag-invalid-page": InvalidPage,
    "ag-workflows-page": WorkflowsPage,
    "ag-connections-page": ConnectionsPage,
    "ag-logs-page": LogsPage,
    "ag-workflow-editor": WorkflowEditor,
    "ag-workspaces-page": WorkspacesPage,
    "ag-users-groups-page": UsersGroupsPage,
    "ag-login-modal": LoginModal,
    "ag-password-modal": PasswordModal,
    "ag-license-modal": LicenseModal
  },

  props: {
    version: String
  },

  data() {
    return {
      page: ""
    };
  },

  computed: {
    isLoading() {
      return this.$store.state.init;
    },

    user() {
      return this.$store.state.userStore.user;
    }
  },

  watch: {
    isLoading() {
      if (!this.user) this.$refs.loginModal.show();
    },

    user() {
      if (this.user) {
        this.$refs.loginModal.hide();
        this.page = "workflows";
      } else {
        this.$refs.loginModal.show();
        this.page = "";
      }
    }
  },

  created() {
    Server.get("validate").promise.then(
      result => {
        if (!result.data.success || !result.data.isValid) {
          this.page = "invalid";
          return;
        }

        this.$store.dispatch("init");
      },
      err => {
        this.showAlert(
          "Server Unavailable",
          "The server is currently unavailable. Please contact your system administrator.",
          "error"
        );
      }
    );

    EventBus.$on("showAlert", params => {
      this.showAlert(params.title, params.message, params.type);
    });
  },

  mounted() {},

  methods: {
    // emitted events

    setPage(page, options) {
      this.page = page;

      // apply options (give time for new page to set)
      setTimeout(() => {
        // apply options
        if (options) {
          // default/global options
          this.$refs.navbar.setTitle(options.title);

          // page specific options
          if (page == "workflowEditor") {
            this.$refs.workflowEditor.isRunning = options.running;
            this.$refs.workflowEditor.isReadonly = options.readonly;
          }
        }

        // reset scroll
        this.$refs.pageContainer.scrollTop = 0;
      }, 250);
    },

    changePassword() {
      this.$refs.passwordModal.show();
    },

    showLicense() {
      this.$refs.licenseModal.show();
    },

    showAlert(title, message, type) {
      this.$refs.alertModal.show(title, message, type);
    }
  }
};
</script>






<style scoped lang="css">
#app {
  width: 100vw;
  height: 100vh;
  margin: 0px;
  padding: 0px;
  overflow: hidden;

  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.agPageContainer {
  max-width: 100% !important;
  height: calc(100% - 60px);
  margin: 60px 0px 0px 0px;
  padding: 0px;
  overflow: auto;
  text-align: center;
}

.agPage {
  width: calc(100% - 50px);
  margin: auto;
  padding: 10px 25px;
}
</style>




// WEBPACK FOOTER //
// src/App.vue